import { UserModel } from 'src/State/User/UserModel'
import { User } from '../models'

const fromUserDtoToModelTransformer = (value: UserModel): User => ({
  id: value.ID || 0,
  addressId: value.Anschrift_ID || 0,
  companyId: value.Firmen_ID || 0,
  ipin: value.ipin || '',
  isReference: value.isReference || false,
  lastUpdate: value.lastUpdate || '',
  level: value.level,
  mailNotification: value.mailNotification || false,
  name: value.Name || '',
  sapEmployeeId: value.sapEmployeeID || 0,
  surname: value.Vorname || '',
  updatedById: value.updatedBy || 0,
  userName: value.username || '',
  password: value?.password,
  infinityCertified: value.infinityCertified || false,
})

export default fromUserDtoToModelTransformer
